export default function(lineKey, that){

    const behaviours = that.$store.state.screen.behaviours
    
    function lineBehvs(behaviours, lineKey){
        if(behaviours[lineKey].navTo){

            // console.log('可以跳转')
            that.$router.replace(behaviours[lineKey].navTo).catch(err=>{})

        }else if(behaviours[lineKey].reproduction){

            // console.log('可以复制到memo');
            // 写复制memo的代码

        }else if(behaviours[lineKey].modify){
            
            // console.log('可以修改');
            // 写修改的代码
        
        }
    }

try{
    switch(lineKey){
        case 'l1':
            lineBehvs(behaviours, lineKey)
            break
        case 'l2':
            lineBehvs(behaviours, lineKey)
            break
        case 'l3':
            lineBehvs(behaviours, lineKey)
            break
        case 'l4':
            lineBehvs(behaviours, lineKey)
            break
        case 'l5':
            lineBehvs(behaviours, lineKey)
            break
        case 'l6':
            lineBehvs(behaviours, lineKey)
            break
        case 'r1':
            lineBehvs(behaviours, lineKey)
            break
        case 'r2':
            lineBehvs(behaviours, lineKey)
            break
        case 'r3':
            lineBehvs(behaviours, lineKey)
            break
        case 'r4':
            lineBehvs(behaviours, lineKey)
            break
        case 'r5':
            lineBehvs(behaviours, lineKey)
            break
        case 'r6':
            lineBehvs(behaviours, lineKey)
            break
    }
}catch(err){err=>{}}

}